import { createElementBlock as n, openBlock as t, createElementVNode as o } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  viewBox: "0 0 24 24"
};
function l(a, e) {
  return t(), n("svg", r, e[0] || (e[0] = [
    o("path", { d: "M17.333 5.34c1.39-.22 2.796-.334 4.205-.34.121 0 .238.043.329.122a.44.44 0 0 1 .133.314v13.73a.44.44 0 0 1-.133.306.46.46 0 0 1-.311.13C14.186 19.708 12 22 12 22m0 0V7.38S9.822 5.096 2.462 5a.5.5 0 0 0-.329.122.44.44 0 0 0-.133.314v13.73a.44.44 0 0 0 .133.306.46.46 0 0 0 .311.13C9.814 19.708 12 22 12 22" }, null, -1),
    o("path", { d: "M12 22a5.67 5.67 0 0 1 1.367-3.135c.967-1.141 2.237-1.923 3.633-2.236V2.443a.45.45 0 0 0-.051-.21.4.4 0 0 0-.14-.154.47.47 0 0 0-.409-.054 6.44 6.44 0 0 0-3.033 2.063A5.86 5.86 0 0 0 12 7.205" }, null, -1)
  ]));
}
const s = { render: l };
export {
  s as default,
  l as render
};
